import React, { useEffect, useState } from 'react';
import "./MsTeamsNotificationEdit.scss";
import { ExternalLink } from '@livingdesign/icons';
import { Button, IconButton } from '@livingdesign/react';
import EditFormActionsFooter from './EditFormActionsFooter';
import { useMessageDetailsForm } from '../../../../../contexts/MessageDetailsForm';
import { useCampaignContext } from '../../../../../contexts/Campaign';
import { TEMPLATE } from '../../../../../consts/DBFields';
import { COPY } from '../../../../../consts/Copy';
import MSTeamsTemplateEditorContainer from './TemplateSection/MSTeamsTemplate/MSTeamsTemplatEditorContainer';

const QA_ID_PREFIX = "MsTeamsNotificationEdit";

function MsTeamsNotificationEdit({

}) {

    const {
        selectedTemplate,
        saveTemplate,
    } = useCampaignContext();

    const {
        continueButtonLoading,
        setContinueButtonLoading,
        handleContinue,
        handlePrevious,
        currentStep,
    } = useMessageDetailsForm();

    const [botContent, setBotContent] = useState(selectedTemplate?.[TEMPLATE.CONTENT]?.trim() || '');


    useEffect(() => {
        if (!selectedTemplate) return;
        setBotContent(selectedTemplate?.[TEMPLATE.CONTENT]?.trim() || '');
    }, [selectedTemplate]);

    return (
        <>
            <div className='ms-teams-notification-edit-container' data-testid={`${QA_ID_PREFIX}-container`}>
                <div className='ms-teams-notification-edit-title' data-testid={`${QA_ID_PREFIX}-title-container`}>
                    <h2 data-testid={`${QA_ID_PREFIX}-heading`}>Build notifications</h2>
                    <p data-testid={`${QA_ID_PREFIX}-description`}>Create a Teams template using MS Adaptive Cards, then copy it into the bot code to complete the template.</p>
                </div>
                <div className='open-ms-teams-builder-wrapper' data-testid={`${QA_ID_PREFIX}-builder-wrapper`}>
                    <div data-testid={`${QA_ID_PREFIX}-icon-button-wrapper`}>
                        <IconButton
                            href={
                                COPY.CAMPAIGN_EDIT.TEMPLATE.NOTIFICATION_BUILDER.LINKS["teams"]
                            }
                            a11yLabel='open-ms-teams-builder-button' size='large'
                            target="_blank"
                            rel="noopener"
                            data-testid={`${QA_ID_PREFIX}-icon-button`}
                        >
                            <ExternalLink size='large' />
                        </IconButton>
                    </div>
                    <div data-testid={`${QA_ID_PREFIX}-builder-info`}>
                        Open a new tab to build your Teams message template using MS Adaptive Cards.
                    </div>
                    <div data-testid={`${QA_ID_PREFIX}-launch-button-wrapper`}>
                        <Button
                            variant='secondary'
                            href={
                                COPY.CAMPAIGN_EDIT.TEMPLATE.NOTIFICATION_BUILDER.LINKS["teams"]
                            }
                            target="_blank"
                            rel="noopener"
                            data-testid={`${QA_ID_PREFIX}-launch-button`}
                        >
                            Launch Teams Builder
                        </Button>
                    </div>
                </div>
                <MSTeamsTemplateEditorContainer
                    loading={continueButtonLoading}
                    botContent={botContent}
                    setBotContent={setBotContent}
                    data-testid={`${QA_ID_PREFIX}-template-editor`}
                />
                <EditFormActionsFooter
                    loading={continueButtonLoading}
                    disableContinue={!botContent}
                    onPrevious={() => handlePrevious()}
                    onSaveDraft={async () => {
                        setContinueButtonLoading(true);
                        await saveTemplate({ content: botContent });
                        setContinueButtonLoading(false);
                    }}
                    onContinue={ async () => {
                        setContinueButtonLoading(true);
                        const res = await saveTemplate({ content: botContent });
                        if(res.success) {
                            await handleContinue(currentStep);
                        }
                        setContinueButtonLoading(false);
                    }}
                    data-testid={`${QA_ID_PREFIX}-form-actions`}
                />
            </div>
        </>
    )
}

export default MsTeamsNotificationEdit;